import capitalize from 'underscore.string/capitalize';
import plural from 'helpers/plural'
import moment from 'moment'

angular
  .module('filters')
  .filter 'membershipPlanDetailedPayments', ($rootScope, $filter) ->
    (plan, currency, detailed) ->
      upfrontPayment = $filter('currency')(plan.cost_upfront, currency)
      repeatPayment = $filter('currency')(plan.cost_repeat, currency)
      intervalUnit = plural(plan.charge_interval_unit, plan.charge_interval_number, plan.charge_interval_number > 1)

      if detailed
        upfrontDate = moment(plan.upfront_payment_on).format('ll')
        recurringStartDate = moment(plan.recurring_payments_start_on).format('ll')
        
        if plan.cost_repeat > 0 and plan.charge_interval_unit
          if plan.cost_upfront > 0
            "First payment of #{upfrontPayment} (to be taken on #{upfrontDate}) and then #{repeatPayment} every #{intervalUnit}, starting #{recurringStartDate}"
          else
            "#{repeatPayment} every #{intervalUnit}, starting #{recurringStartDate}"
        else
          if plan.cost_upfront > 0
            "Up-front payment of #{upfrontPayment}, to be taken on #{upfrontDate}"
          else
            "Free plan"
      else
        if plan.cost_repeat > 0 and plan.charge_interval_unit
          if plan.cost_upfront > 0
            "First Payment #{upfrontPayment} and then #{repeatPayment} every #{intervalUnit}"
          else
            "#{repeatPayment} paid every #{intervalUnit}"
        else
          if plan.cost_upfront > 0
            "Up-front payment of #{upfrontPayment}"
          else
            "Free plan"
